import { FC } from "react";
import { useTranslation } from "react-i18next";

import { SVG_MUI } from "@ryde/assets";
import { NumberTemplate } from "@ryde/controls";

import {
  BulkPassengersMessageFormFieldsEnum,
  RIDES_PARTICIPATION_FILTER_DESCRIPTION_ID,
  RIDES_PARTICIPATION_FILTER_TITLE_ID,
} from "./bulk-passengers-message.models";
import { RidesParticipationFilterStyled } from "./bulk-passengers-message.styled";

/**
 * Narrows the recipients to active passengers who took part in a ride recently.
 *
 * Passengers page only: the rides flow already scopes recipients to the passengers on the selected
 * rides, so the filter has nothing left to narrow there.
 */
export const RidesParticipationFilter: FC = () => {
  const { t } = useTranslation();

  return (
    <RidesParticipationFilterStyled
      aria-labelledby={RIDES_PARTICIPATION_FILTER_TITLE_ID}
    >
      <span className="rides-participation-filter__icon">
        <SVG_MUI.FilterSVG width={20} height={20} aria-hidden />
      </span>

      <span className="rides-participation-filter__text">
        <span
          id={RIDES_PARTICIPATION_FILTER_TITLE_ID}
          className="rides-participation-filter__title"
        >
          {t("passenger.sendPassengerMessageForm.ridesParticipationFilter")}
        </span>
        <span
          id={RIDES_PARTICIPATION_FILTER_DESCRIPTION_ID}
          className="rides-participation-filter__description"
        >
          {t(
            "passenger.sendPassengerMessageForm.ridesParticipationFilterDescription",
          )}
        </span>
      </span>

      <span className="rides-participation-filter__field">
        <NumberTemplate
          name={BulkPassengersMessageFormFieldsEnum.lastRideWithinDays}
          labelTranslated={t(
            "passenger.sendPassengerMessageForm.lastRideWithinDays",
          )}
          placeholder={t(
            "passenger.sendPassengerMessageForm.lastRideWithinDaysHint",
          )}
          ariaDescribedBy={RIDES_PARTICIPATION_FILTER_DESCRIPTION_ID}
          formAttributes={{ intRounding: true }}
        />
      </span>
    </RidesParticipationFilterStyled>
  );
};
